import { render, staticRenderFns } from "./standcostapply.vue?vue&type=template&id=6d760b03&scoped=true&"
import script from "./standcostapply.vue?vue&type=script&lang=js&"
export * from "./standcostapply.vue?vue&type=script&lang=js&"
import style0 from "./standcostapply.vue?vue&type=style&index=0&id=6d760b03&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d760b03",
  null
  
)

export default component.exports